/**
 * ブラウザ通知（Web Push）の対象判定。Vue 非依存の純関数。
 */

// plugins/device-lib.js の isMobileDevice と同じ判定。
// スマホはアプリへ誘導する方針なので、ブラウザ通知の対象は PC のみ。
const MOBILE_UA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone/i

export const isMobileUserAgent = (userAgent: string): boolean =>
  MOBILE_UA.test(userAgent)

/** appId と VAPID 鍵の両方が入っている環境だけ Web Push を有効にする */
export const isWebPushConfigured = (appId: string, vapidKey: string): boolean =>
  !!appId && !!vapidKey

/**
 * 同じ通知を複数タブで表示しないための識別子。
 * notification_id（= varuna の push_notification_log.log_id）があればそれを使う。
 */
export const foregroundNotificationKey = (
  data: Record<string, string> | undefined,
  title: string,
  body: string
): string => (data && data.notification_id) || `${title}|${body}`
